import React, { memo } from "react";

/**
 * HeadlineParagraph component.
 * Renders a section with a title and a description.
 * @param {Object} data - The data for the component.
 * @param {Object} data.cardItem - The card item data.
 * @param {string} data.cardItem.title - The title of the section.
 * @param {string} data.cardItem.description.description - The description of the section.
 */
const HeadlineParagraph = ({ data }) => {
    // Destructuring the data
    const { cardItem, customId } = data ?? {};
    const { title, description } = cardItem ?? {};

    // Setting the gap class based on the existence of title and description
    const gapClass = title && description ? "mb-5" : "";

    return (
        // Rendering the section with padding and background color
        <section className="py-15 md:py-20 lg:py-30 bg-stone-light" id={customId}>
            <div className="container">
                <div className="row">
                    <div className="col-12 xl:col-10 xl:mx-auto">
                        {/* Rendering the title if it exists */}
                        {title && <h2 className={`text-center ${gapClass}`}>{title}</h2>}
                        {/* Rendering the description if it exists */}
                        {description?.description && (
                            <p className="text-center text-lg md:text-xl lg:text-2xl leading-relaxed tracking-tight6 font-light">
                                {description?.description}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

// Exporting the component using memo for performance optimization
export default memo(HeadlineParagraph);
